export default { options: { label: 'Rounds' } }
